/* rs-review-text-fix.js - display-only mojibake repair for migrated Air Reviews text, and (2026-10-16) hide-on-error for
   review photos still hosted on www.rareseeds.com/media (why: header comment of snippets/rs-review-text-fix.liquid, which
   loads this file). launch readiness pass 2, 2026-09-24: moved out of the inline
   <script>; loaded with `defer` - it already boots on DOMContentLoaded and re-scans on DOM mutations, so timing is unchanged. */
(function () {
  // UTF-8 lead byte (0xC2-0xF4) immediately followed by a continuation byte (0x80-0xBF)
  var SIG = /[\u00C2-\u00F4][\u0080-\u00BF]/;
  var ROOTS = '.AirReviews-Widget__V2, .AirReviews-Embed-BlockWrapper, .AirReviews-Toast__Container';

  function repair(s) {
    if (!s || !SIG.test(s)) return s;
    try {
      var bytes = new Uint8Array(s.length);
      for (var i = 0; i < s.length; i++) bytes[i] = s.charCodeAt(i) & 0xFF;
      var out = new TextDecoder('utf-8', { fatal: false }).decode(bytes);
      return out.indexOf('\uFFFD') > -1 ? s : out; // bail if decode was lossy
    } catch (e) { return s; }
  }

  function scan(root) {
    if (!root) return;
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var n, jobs = [];
    while ((n = w.nextNode())) {
      var v = n.nodeValue;
      if (v && SIG.test(v)) { var f = repair(v); if (f !== v) jobs.push([n, f]); }
    }
    for (var i = 0; i < jobs.length; i++) jobs[i][0].nodeValue = jobs[i][1];
  }

  var queued = false;
  function scanAll() {
    queued = false;
    var roots = document.querySelectorAll(ROOTS);
    for (var i = 0; i < roots.length; i++) scan(roots[i]);
    sweepBroken(); // re-renders on sort/paginate re-inject thumbnails
  }
  function schedule() {
    if (queued) return; queued = true;
    // setTimeout (not requestAnimationFrame) so it still fires if the widget
    // renders while the tab is backgrounded — rAF is paused in hidden tabs.
    setTimeout(scanAll, 50);
  }

  // 2026-10-16: migrated review photos hot-link www.rareseeds.com/media (Magento). After the
  // 2026-10-19 DNS move those URLs 404 on Shopify (no /media redirect can exist) until Avada
  // rewrites the hosts. Hide a thumbnail the moment its <img> errors; drop the block when none
  // survive (also removes the background-image "+N" tile). No-op once the URLs are fixed.
  // Only an <img> that has actually been given a src counts: the widget lazy-loads thumbnails as
  // <img data-src> with no src, and such an image reports complete=true/naturalWidth=0 before it
  // ever loads - treating that as broken hid every healthy photo (seen on the scratch theme).
  function hideBroken(img) {
    if (!img.getAttribute('src')) return;
    var thumb = img.closest && img.closest('.AirReviews-Thumbnail');
    if (!thumb) return;
    thumb.hidden = true; thumb.style.display = 'none';
    var wrap = thumb.closest('.AirReviews-Blocks__Images');
    if (wrap && !wrap.querySelector('.AirReviews-Thumbnail:not([hidden]) img')) wrap.style.display = 'none';
  }
  document.addEventListener('error', function (e) {
    if (e.target && e.target.tagName === 'IMG') hideBroken(e.target);
  }, true); // error does not bubble; capture catches images the widget injects later
  function sweepBroken() {
    var imgs = document.querySelectorAll('.AirReviews-Blocks__Images img');
    for (var i = 0; i < imgs.length; i++) {
      if (imgs[i].getAttribute('src') && imgs[i].complete && imgs[i].naturalWidth === 0) hideBroken(imgs[i]);
    }
  }

  function boot() {
    scanAll();
    // Air Reviews renders async and re-renders on sort/paginate - watch for it.
    // childList only: our nodeValue edits emit characterData mutations, not
    // childList, so this never re-triggers on our own fixes (no loop).
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
